import type { OrganizationSettings, OrganizationSettingsRequest } from "@shyne/shared/api";
import { useAppDispatch, useAppSelector } from "@/lib/store.ts";
import { useEffect, useState } from "react";
import {
  fetchOrganization,
  updateOrganization,
  uploadOrgAvatar,
} from "@/app/organization/settings/organization/organization.slice.ts";
import { organizationShown } from "@/lib/store/organization.slice";
import { useAdministersActiveOrganization } from "@/hooks/useAdministersActiveOrganization";

export const useOrganizationSettings = () => {
  const dispatch = useAppDispatch();
  const { data, loading, saving, uploadingAvatar } = useAppSelector((state) => state.organizationSettings);
  const activeOrgId = useAppSelector((state) => state.organization.activeOrgId);
  const editable = useAdministersActiveOrganization();
  const [sameAsSupport, setSameAsSupport] = useState(true);

  useEffect(() => {
    if (activeOrgId) dispatch(fetchOrganization());
  }, [dispatch, activeOrgId]);

  const shown = (settings: OrganizationSettings): OrganizationSettings => {
    dispatch(organizationShown({ id: settings.id, name: settings.name, logo: settings.logo }));
    return settings;
  };

  const handleSave = async (settings: OrganizationSettingsRequest): Promise<OrganizationSettings> => shown(await dispatch(updateOrganization(settings)).unwrap());

  const handleLogoUpload = async (file: File): Promise<OrganizationSettings> => shown(await dispatch(uploadOrgAvatar(file)).unwrap());

  return {
    organization: data,
    loading,
    uploadingLogo: uploadingAvatar,
    saving,
    editable,
    handleSave,
    handleLogoUpload,
    sameAsSupport,
    setSameAsSupport,
  };
};
